// extracted by mini-css-extract-plugin
module.exports = {"CountTableAfter":"CountTableAfter_CountTableAfter__1PfZu"};